<template>
    <div class="row network-access-dtc-owner">
        <div class="col-xs-12">
            <h4 class="half-line h-secondary margin-md-bottom">Network Credentials</h4>
          <div v-if="isMultiSignatureDisabled">
            <p>
              You will see your home's network credentials when all leaseholders have signed the amenity addendum.
            </p>
          </div>
          <div v-else style="max-width: 400px;">
            <p>
              Use these credentials to connect to your internet service.
            </p>
            <span style="position: absolute; bottom: 152px; left: 23px; font-size: 10px; background-color: white; color: rgb(161 161 161);">SSID</span>
            <p style="width: 100%; display: flex;">
              <input
                  id="ssid"
                  disabled style="border: 1px solid #e5e5e5; border-radius: 5px; padding: 15px; width: 75%; background-color: white;"
                  class="copy-text"
                  :value="ssid"
                  v-on:focus="$event.target.select()"
              />
              <button style="margin-left: 15px; background: none; border: none;" @click="copyToClipboard('ssid', 'ssid-text')" class="copy-to-clipboard">
                    <span style="margin-left: 15%; padding: 5px 10px; height: 10%; border: 1px solid #e5e5e5; border-radius: 5px;">
                        <i class="fa fa-clone copy-icon tool-tip" aria-hidden="true">
                        <span id="ssid-text" class="copy-text-tool-tip">Copied!</span>
                        </i>
                    </span>
              </button>
            </p>
            <span style="position: absolute; bottom: 70px; left: 23px; font-size: 10px; background-color: white; color: rgb(161 161 161);">Password</span>
            <p style="width: 100%; display: flex;">
              <input
                  id="ssid-passcode"
                  disabled style="border: 1px solid #e5e5e5; border-radius: 5px; padding: 15px; width: 75%; background-color: white;"
                  class="copy-text"
                  :type="showPass ? 'text' : 'password'"
                  :value="ssidPasscode"
                  v-on:focus="$event.target.select()"
              />
              <span v-if="!showPass" style="position: relative; right: 50px; top: 16px; cursor: pointer" @click="showPass = !showPass"><i class="fa fa-eye" style="font-size: larger;" aria-hidden="true"/></span>
              <span v-else style="position: relative; right: 50px; top: 16px; cursor: pointer" @click="showPass = !showPass"><i class="fa fa-eye-slash" style="font-size: larger;" aria-hidden="true"/></span>
              <button @click="copyToClipboard('ssid-passcode', 'ssid-passcode-text')" class="copy-to-clipboard" style="background: none; border: none;">
                    <span style="margin-left: 5%; padding: 5px 10px; height: 10%; border: 1px solid #e5e5e5; border-radius: 5px;">
                        <i class="fa fa-clone copy-icon tool-tip" aria-hidden="true">
                        <span id="ssid-passcode-text" class="copy-text-tool-tip">Copied!</span>
                        </i>
                    </span>
                </button>
            </p>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ssid: {
            required: false,
            type: String,
        },
        ssidPasscode: {
            required: false,
            type: String,
        },
        isMultiSignatureDisabled: {
            required: false,
            type: String,
        }
    },

    data() {
        return {
          showPass: false
        };
    },

    computed: {
    },

    methods: {
        copyToClipboard(inputElementId, tooltipElementId) {
            let inputElement = document.getElementById(inputElementId);
            let tooltipTextElement = document.getElementById(tooltipElementId);
            let textToCopy = inputElement.value;
            // Copy text to clipboard
            navigator.clipboard.writeText(textToCopy);
            // Display to the user that the text was copied
            tooltipTextElement.classList.add("active");
            setTimeout(() => {
                tooltipTextElement.classList.remove("active");
            }, 750);
        }
    }
}
</script>